import { Col, Space, Typography } from "antd";
import routes from "../../../engine/routes";
import React from "react";
import { useParams } from "react-router-dom";
import { RenderTitle } from "../../../engine/AuthRoute/navigationHelper";
import LogHistory from "../LogHistory";
import { useSelector } from "react-redux";
import { roles } from "../../../utils/constants";
import { ActionRoleSpecific } from "../../../engine/AuthRoute";
import { BillAction } from "../BillAction/BillAction";

export const BillHeader = ({ title }) => {
  const { loading, bill } = useSelector(state => state.bill);

  return (
    <Col span={24} style={{ marginBottom: 20 }}>
      <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
        <LogHistory updateEndPoint={[loading]} />
      </ActionRoleSpecific>
      <Space
        style={{
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={3} className={""}>
          <RenderTitle title={title} />
        </Typography.Title>
        <BillAction />
      </Space>
    </Col>
  );
};
